// extracted by css-extract-rspack-plugin
export default {"info":"info-Kyz84T","infoLink":"infoLink-coB3g5","infoIcon":"infoIcon-vXUtoF"};